module.exports = __webpack_public_path__ + "img/the-netherlands-cervical-cancer-female.89de9c76.png";